import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tooltipText", "tooltipIcon"];

  tooltipHandleClick() {
    this.tooltipTextTarget.style.display = this.tooltipTextTarget.style.display === "flex" ? "none" : "flex";
    this.tooltipIconTarget.classList.toggle("open");
  }
}
